<template>
  <div>
    <!-- <MarkMaintenance :mtSchedule="mtSchedule"></MarkMaintenance> -->
    <DetailAction :mtAction="mtAction" :mtSchedule="mtSchedule"></DetailAction>
    <MasterLayout>
      <section class="mt-3 full__row_section">
        <div class="row">
          <div class="col-md-4">
            <div class="dashboard__card large_card card_padding indus_back_img">
              <div
                class="row make-row-hundred-percent align-items-center justify-content-center"
              >
                <div class="col-md-3">
                  <div
                    class="icon_wrapper yellow centralize icon_div_big"
                    style=""
                  >
                    <img src="@/assets/img/clock (1).svg" width="48" />
                  </div>
                </div>
                <div class="col-md-7 remove-padding-left">
                  <div class="text-center">
                    <h6 class="text-white">
                      {{ $t("text.iScheduleMaintenance.nextMaintenance") }}
                    </h6>
                  </div>
                  <div class="text-center mt-4">
                    <h5 class="text-white mt-4 font-weight">
                      {{ nextScheduleDayCount }}
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-8 remove-padding-left padding_div">
            <div class="dashboard__card small_card align-center">
              <div class="card_inner_wrapper">
                <!-- <div class="card_inner_wrapper_header_container">
                                
                            </div> -->
                <div class="row make-row-hundred-percent">
                  <div class="col-md-8">
                    <h3 class="card_inner_wrapper_header">
                      {{ $t("text.iScheduleMaintenance.hi") }}, {{ userName }}
                    </h3>
                    <h3 class="card_inner_wrapper_para mt-4">
                      {{ $t("text.iScheduleMaintenance.youCanFix") }}
                    </h3>
                  </div>
                  <div class="col-md-4 mt-4">
                    <router-link
                      :to="{
                        name: 'industrialBranchAddMaintenance',
                        query: {
                          branchId: $route.query.branchId
                            ? this.$route.query.branchId
                            : '',
                          companyId: $route.query.companyId,
                          groupId: $route.query.groupId,
                        },
                      }"
                      class="vue_router_link btn btn_theme yellow_text"
                    >
                      {{ $t("text.iScheduleMaintenance.schedule") }}
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="mt-3 full__row_section">
        <ejs-grid
          ref="dataGrid"
          v-show="!showLoader"
          :created="refreshGrid"
          :allowPaging="true"
          :allowSorting="true"
          :pageSettings="pageSettings"
          :toolbar="toolbar"
          :searchSettings="search"
          :allowExcelExport="true"
          :allowPdfExport="true"
          :toolbarClick="toolbarClick"
          :rowDataBound="rowDataBound"
          :locale="usedLang"
        >
          <e-columns>
            <e-column field="index" width="100" headerText="#"></e-column>
            <e-column
              field="type"
              width="180"
              :headerText="$t('text.iScheduleMaintenance.facilityType')"
            ></e-column>
            <e-column
              field="typeName"
              width="200"
              :headerText="$t('text.iScheduleMaintenance.facilityName')"
            ></e-column>
            <e-column
              field="status"
              width="120"
              :headerText="$t('text.iScheduleMaintenance.status')"
            ></e-column>
            <e-column
              field="scheduleDate"
              width="200"
              :headerText="$t('text.iScheduleMaintenance.dueDate')"
            ></e-column>
            <e-column></e-column>
            <e-column
              :template="countDownTemplate"
              field="cd"
              width="180"
              :headerText="$t('text.iScheduleMaintenance.dueDate')"
            >
            </e-column>
            <e-column
              :template="detailTemplate"
              field="Actions"
              width="120"
            ></e-column>
          </e-columns>
        </ejs-grid>
      </section>
      <section class="mt-3 full__row_section">
        <TableLoader :showLoader="showLoader" />
      </section>
    </MasterLayout>
  </div>
</template>

<script>
import Vue from "vue";
import MasterLayout from "@/views/Industrial/MasterLayout.vue";
import cardBackgroundUrl from "@/assets/img/Group393.svg";
import { Chart } from "highcharts-vue";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import backImg from "@/assets/img/pattern_img.png";
import { VueApexCharts } from "apexcharts";
import { VueperSlides, VueperSlide } from "vueperslides";
import "vueperslides/dist/vueperslides.css";
import DetailAction from "@/components/modals/detailAction/index";
// import MarkMaintenance from "@/components/modals/markMaintenance/index";

import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
} from "@syncfusion/ej2-vue-grids";

import JQuery from "jquery";
let $ = JQuery;

export default {
  title: "Schedule Maintenance:: Epump Industrial Portal",
  name: "DashboardHome",
  components: {
    MasterLayout,
    Highcharts: Chart,
    VueApexCharts,
    VueperSlides,
    VueperSlide,
    // MarkMaintenance,
    DetailAction,
    TableLoader,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport],
  },
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      // linkQuery: {
      //   branchId: this.$route.query.branchId,
      //   companyId: this.$route.query.companyId,
      // },
      backImg,
      nextScheduleDayCount: 0,
      userDetails: localStorage.getItem("userDetails")
        ? JSON.parse(localStorage.getItem("userDetails"))
        : null,
      showLoader: true,
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["Search"],
      search: { operator: "contains", ignoreCase: true },
      industryBranch: null,
      industryBranchId: null,
      maintSchedules: [],
      mtSchedule: {},
      mtAction: [],
      countDown: [],
      actionTemplate: function () {
        return {
          template: Vue.component("actionTemplate", {
            template:
              "<div>" +
              '<button @click="trackHistory" class="btn btn-warning text-white"><i class="fa fa-history mr-1" aria-hidden="true" style="color: white"></i>Track History</button> ' +
              '<button @click="openModal"   class="btn btn-info"><i class="fa fa-check-square-o mr-1" aria-hidden="true" style="color: white"></i>Mark As Done</button>' +
              // '<a class="btn btn_primary mr-2" style="background: #f19b15  !important; color: antiquewhite " :href="`/Industrial/Branch/maintenance-history?typeName=` + data.typeName" @click="link($event, \'industrialBranchMaintenanceHistory\', data)"><i class="fa fa-history mr-1" aria-hidden="true" style="color: white"></i>{{data.history}}</a>' +
              // '<button class="btn btn_primary" style="background: #dae7ec !important; color: green !important;box-shadow: 0px 3px 3px #0000000D;box-shadow: 0px 3px 3px #0000000D; "  @click="openModal(data)"  ><i class="fa fa-check-square-o mr-1" aria-hidden="true" style="color: green"></i>{{data.markAsDone}}</button>' +
              "</div>",
            data: function () {
              return {
                data: {},
              };
            },
            methods: {
              trackHistory() {
                if (this.$route.branchId) {
                  this.$router.push(
                    `/Industrial/Branch/maintenance-history?typeName=${this.data.typeName}&branchId=${this.$route.query.branchId}&companyId=${this.$route.query.companyId}`
                  );
                } else {
                  this.$router.push(
                    `/Industrial/Branch/maintenance-history?typeName=${this.data.typeName}`
                  );
                }
                // console.log(this.data)
              },
              openModal(data) {
                this.$eventHub.$emit("_openModal", data);
              },
              link($event, url, data) {
                $event.preventDefault();
                this.$eventHub.$emit("_link", url, data);
              },
            },
          }),
        };
      },
      countDownTemplate: function () {
        return {
          template: Vue.component("actionTemplate", {
            template: ` 
                     <div class="row align-items-center" style="margin: 0 auto">
                        <div class="col-md-1">
                            <span class=""> <i class="fa fa-clock-o" aria-hidden="true"  style="color: #0d041d96; font-size: 25px"></i></span>
                        </div>
                        <div class="col-md-3">
                            <span class="">{{data.countdown}}</span>
                        </div>
                    </div>
                    `,
            data: function () {
              return {
                data: {},
              };
            },
            methods: {},
          }),
        };
      },
      detailTemplate: function () {
        return {
          template: Vue.component("detailTemplate", {
            template:
              "<div>" +
              '<button @click="openDetail(data)" class="btn btn-info text-white">Details</button> ' +
              "</div>",
            data: function () {
              return {
                data: {},
              };
            },
            methods: {
              // openDetail(data) {
              //  // console.log("clicked")

              //   this.$eventHub.$emit("_openDetail", data);

              // }
              openDetail: function (data) {
                this.$eventHub.$emit("_openDetail", data);
                //  console.log(data);
              },
            },
          }),
        };
      },
    };
  },
  created() {
    this.$eventHub.$on("_link", (url, data) => {
      this.$router.push({
        name: url,
        query: {
          typeName: data.typeName,
        },
      });
    });

    // this.$eventHub.$on("_openModal", (data) => {
    //   this.showModal(data);
    // });

    this.$eventHub.$on("_openDetail", (data) => {
      this.showModal(data);
      this.openDetail(data);
    });

    this.$eventHub.$on("industryBranch", (industryBranch) => {
      this.industryBranch = industryBranch;
      document.title = `Industry Dashboard - ${industryBranch.name}`;
      $(".e-input").keyup(function (e) {
        searchFun(e);
      });
      function searchFun(event) {
        var grid =
          document.getElementsByClassName("e-grid")[0].ej2_instances[0];
        var value = event.target.value;
        grid.search(value);
      }
    });
    let _this = this;
    this.$eventHub.$on("refreshMaintList", () => {
      this.getMaintenanceSchedules();
    });
  },
  beforeDestroy() {
    this.$eventHub.$off("refreshMaintList");
  },
  watch: {
    industryBranch: function (newIndustry, oldIndustry) {
      if (newIndustry.id !== null) {
        this.industryBranchId = newIndustry.id;

        this.getMaintenanceSchedules();
      }
    },
  },
  computed: {
    userName() {
      if (localStorage.getItem("userDetails")) {
        return this.userDetails.firstName + "  " + this.userDetails.lastName;
      } else {
        return "Username";
      }
    },
  },
  mounted() {
    if (screen.width <= 575) {
      document
        .querySelector(".padding_div")
        .classList.remove("remove-padding-left");
      document.querySelector(".padding_div").style.marginTop = "15px";
    }
  },
  methods: {
    showModal(data) {
      const mtSchedule = this.maintSchedules.filter(
        (el) => el.index === data.index
      )[0];
      this.mtSchedule = mtSchedule;
      // this.$modal.show("markMaint");
      // this.$modal.show("detailActt");
    },
    openDetail(data) {
      this.mtAction = data;
      // this.$eventHub.$emit("setWaybill", data);
      // this.waybill = waybill;

      this.$modal.show("detailActt");
    },
    rowDataBound: function (args) {
      if (
        args.data["status"] === this.$t("text.iScheduleMaintenance.pending")
      ) {
        args.row.cells[3].style.color = "red";
      }
      if (args.data["status"] === this.$t("text.iScheduleMaintenance.done")) {
        args.row.cells[3].style.color = "green";
      }
      if (
        args.data["countdown"] === this.$t("text.iScheduleMaintenance.expired")
      ) {
        args.row.cells[6].style.color = "red";
      } else {
        args.row.cells[6].style.color = "green";
      }
    },
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          this.$refs.dataGrid.pdfExport();
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    refreshGrid() {
      if (this.$refs.dataGrid) {
        this.$refs.dataGrid.refresh();
      }
    },
    getMaintenanceSchedules() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Branch/MaintenanceRequests/${this.industryBranch.id}`,
          configObject.authConfig()
        )
        .then((res) => {
          let index = 0;
          let countDownDays = [];
          let CountDownHours = [];
          res.data.forEach((el) => {
            index++;
            el.index = index;
            el.history = this.$t("text.iScheduleMaintenance.history");
            el.markAsDone = this.$t("text.iScheduleMaintenance.markAsDone");
            const total =
              Date.parse(new Date(el.scheduleDate)) - Date.parse(new Date());
            const days = Math.floor(total / (1000 * 60 * 60 * 24));
            const hours = Math.floor(total / (1000 * 3600));

            if (days === 0) {
              el.countdown =
                hours + " " + this.$t("text.iScheduleMaintenance.hours");
              CountDownHours.push(hours);
              countDownDays.push(days);
            } else if (days < 0) {
              el.countdown = this.$t("text.iScheduleMaintenance.expired");
            } else if (days === 1) {
              el.countdown =
                days + " " + this.$tc("text.iScheduleMaintenance.day", 1);
              countDownDays.push(days);
            } else if (days > 1) {
              el.countdown =
                days + " " + this.$tc("text.iScheduleMaintenance.day", 2);
              countDownDays.push(days);
            }
            if (
              el.scheduleDate === null ||
              el.scheduleDate === "null" ||
              el.scheduleDate === undefined ||
              !el.scheduleDate
            ) {
              el.scheduleDate = "N/A";
            } else {
              el.scheduleDate = this.$moment(el.scheduleDate).format(
                "MMMM D, YYYY h:mm A"
              );
            }
            if (
              el.date === null ||
              el.date === "null" ||
              el.date === undefined ||
              !el.date
            ) {
              el.date = "N/A";
            } else {
              el.date = this.$moment(el.date).format("MMMM D, YYYY h:mm A");
            }
            if (el.resolved) {
              el.status = this.$t("text.iScheduleMaintenance.done");
            } else {
              el.status = this.$t("text.iScheduleMaintenance.pending");
            }
            const minCountDown = Math.min(...countDownDays);
            if (minCountDown == Infinity) {
              this.nextScheduleDayCount = "No Upcoming Schedules";
              return;
            }
            if (minCountDown > 1) {
              this.nextScheduleDayCount =
                minCountDown +
                "  " +
                this.$tc("text.iScheduleMaintenance.day", 2);
            } else if (minCountDown === 1) {
              this.nextScheduleDayCount =
                minCountDown +
                "  " +
                this.$tc("text.iScheduleMaintenance.day", 1);
            } else {
              const minCountDownHours = Math.min(...CountDownHours);
              this.nextScheduleDayCount =
                minCountDownHours +
                " " +
                this.$t("text.iScheduleMaintenance.hours");
            }
          });
          this.showLoader = false;
          this.$refs.dataGrid.ej2Instances.setProperties({
            dataSource: res.data,
          });
          this.maintSchedules = res.data;
          this.refreshGrid();
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
  },
};
</script>
